import React, { useState } from 'react';
import Welcome from './Welcome';
import Chat from './Chat';

// Identificador anónimo del cliente, guardado en este dispositivo. No hay
// autenticación: con este id reconocemos al cliente y reabrimos su conversación.
const UID_KEY = 'chatUid';

function generarUid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return 'u-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
}

export default function ChatPage() {
  const [uid, setUid] = useState(() => localStorage.getItem(UID_KEY));

  const iniciar = () => {
    let id = localStorage.getItem(UID_KEY);
    if (!id) {
      id = generarUid();
      localStorage.setItem(UID_KEY, id);
    }
    setUid(id);
  };

  // Si ya hay un id guardado, entra directo al chat; si no, muestra la bienvenida.
  if (!uid) {
    return <Welcome onIniciar={iniciar} />;
  }

  return <Chat phone={uid} />;
}
